export const COLORS = {
    red: "#FD0014",
    white: "#fff",
    lightgray:"#505050",
    darkyellow:'#F9DF4E',
    lightblue: '#4A5BCF',
    lightred:'#FF4F4F',
    darkblue: '#0A004B'
    
}

export const SIZES = {
    h3: "48px",
    h4: "36px",
    h5: "16px",
    h6: "14px",
    padding: "50px"
}

